import React from 'react';

type NavBadgeProps = {
  count: number;
  /** Cap above which the badge shows `${cap}+`. Defaults to 99 per Figma. */
  cap?: number;
};

/**
 * Red unread-count pill shown at the top-right of a nav tab icon (JAA-266).
 * Renders nothing when count <= 0. Caps the displayed value at `cap` ("99+").
 * Generic so any tab can adopt it later; currently only Activity uses it.
 */
const NavBadge: React.FC<NavBadgeProps> = ({ count, cap = 99 }) => {
  if (count <= 0) return null;
  const label = count > cap ? `${cap}+` : `${count}`;
  return (
    <span className="jaakko-nav__badge" aria-hidden="true">
      {label}
    </span>
  );
};

export default NavBadge;
